import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { InputSearchCriteria } from 'app/dashboard/leads/visits-request';

@Component({
  selector: 'app-customfield-device',
  templateUrl: './customfield-device.component.html',
  styleUrls: ['./customfield-device.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CustomfieldDeviceComponent implements OnInit {
  @Input() inputSearchCriteria: InputSearchCriteria;
  public selectedOption = 1;
  @Output() addCriteria = new EventEmitter<InputSearchCriteria>();
  public helpText: string;

  constructor() {}

  ngOnInit() {
    if (this.inputSearchCriteria.operator == 7 && this.inputSearchCriteria.input == 760) {
      this.selectedOption = 0;
    } else if (this.inputSearchCriteria.operator == 6 && this.inputSearchCriteria.input == 760) {
      this.selectedOption = 1;
    } else {
      // default
      this.inputSearchCriteria.operator = 6;
      this.inputSearchCriteria.input = 760;
      this.inputSearchCriteria.displayExp = 'Desktop';
    }
  }

  public setResolution() {
    if (this.selectedOption == 0) {
      this.inputSearchCriteria.operator = 7; //Less than
      this.inputSearchCriteria.input = 760;
      this.inputSearchCriteria.displayExp = 'Mobile';
    } else if (this.selectedOption == 1) {
      this.inputSearchCriteria.operator = 6; //More Than
      this.inputSearchCriteria.input = 760;
      this.inputSearchCriteria.displayExp = 'Desktop';
    }

    this.addCriteria.emit(this.inputSearchCriteria);
  }
}
